import axios from "axios";
// import { MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { API_BASE_URL } from "@/utils/config";
import i18n from "@/i18n";
// import router from "@/router";
// console.log(API_BASE_URL, 'API_BASE_URL')

// create an axios instance
const service = axios.create({
  baseURL: API_BASE_URL, // url = base url + request url
  // baseURL: '/api', // url = base url + request url
  // baseURL: '/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
});

function generateBasicAuthHeader(username, password) {
  // 将用户名和密码拼接成 "username:password" 的形式
  const credentials = `${username}:${password}`;
  // console.log(credentials, '===>2')
  let base64Credentials = "";
  if (typeof btoa === "undefined") {
    base64Credentials = new Buffer.from(credentials, "binary").toString(
      "base64"
    );
  }
  if (typeof btoa !== "undefined") {
    base64Credentials = btoa(credentials);
  }
  // 使用 btoa() 函数将字符串进行 Base64 编码
  // 构建 Authorization 头部
  const authHeader = `Basic ${base64Credentials}`;
  return authHeader;
}

/** 根据当前界面语言生成接口约定的语言请求头：中文为 1，英文为 2。 */
function getRequestLanguage() {
  return i18n.locale === "zh-CN" ? "1" : "2";
}

// request interceptor 请求拦截
service.interceptors.request.use(
  (config) => {
    config.headers["platform"] = "pc";
    // console.log(config, API_BASE_URL, 'API_BASE_URL')
    let token = getToken();
    config.headers["language"] = getRequestLanguage();

    // do something before request is sent
    // 这里做了请求类型的判断 为请求头添加对应的content-type类型
    if (config.url.indexOf("/oauth2/token") != -1) {
      token = generateBasicAuthHeader("app", "app");
      config.headers["Authorization"] = token;
      // console.log(config.headers["Authorization"]);
      return config;
    }

    if (token) {
      // config.headers['Authorization'] = 'Bearer ' + token
      config.headers["user-token"] = token;
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor 响应拦截
service.interceptors.response.use(
  (response) => {
    // console.log(response, 'resreresponseresponseresponsesresresresresres')
    const res = response.data;

    if (res.code != 1) {
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code == -201 || res.code == -202 || res.code == -204) {
        // to re-login
        // console.log(res, 'resresresresresresres')

        // 登录失效，跳转登录页
        store.dispatch("user/logout").then(() => {
          store.commit("SET_LOGIN_SHOW", true);
        });
      }
      return res;
      // return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res;
    }
  },
  (error) => {
    const status = error && error.response && error.response.status;
    console.log("响应返回错误" + (status || error.message || "")); // for debug
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000,
    // });
    // console.log('this---', this)

    if (status == 424) {
      // 登录过期，跳转登录页
      store.dispatch("user/logout").then(() => {
        store.commit("SET_LOGIN_SHOW", true);
      });
    }
    return Promise.reject(error);
  }
);

export default service;
